import { endOfMonth, getDay, getDaysInMonth, startOfMonth } from 'date-fns';
import { leftPad } from '../utils';
export var isCurrentDayAndRangeSelection = function isCurrentDayAndRangeSelection(_ref) {
  var current = _ref.current,
    rangeSelection = _ref.rangeSelection;
  if (current && current.length > 0 && rangeSelection) {
    return true;
  }
  return false;
};
export var buildIso = function buildIso(year, month, day) {
  return day ? "".concat(year, "-").concat(leftPad(month + 1, 2, 0), "-").concat(leftPad(day, 2, 0)) : undefined;
};
export var withinRange = function withinRange(_ref2) {
  var current = _ref2.current,
    hoveredDate = _ref2.hoveredDate,
    value = _ref2.value,
    rangeSelection = _ref2.rangeSelection;
  if (isCurrentDayAndRangeSelection({
    current: current,
    rangeSelection: rangeSelection
  })) {
    if (value && value[0] && value[1] && current) {
      return current > value[0] && current < value[1];
    }
    if (hoveredDate && value && value[0] && current) {
      if (hoveredDate > value[0]) {
        return current > value[0] && current < hoveredDate;
      }
      return current > hoveredDate && current < value[0];
    }
    return false;
  }
  return false;
};
export var rangeEnd = function rangeEnd(_ref3) {
  var current = _ref3.current,
    hoveredDate = _ref3.hoveredDate,
    hoveredDay = _ref3.hoveredDay,
    mDay = _ref3.mDay,
    shownMonth = _ref3.shownMonth,
    shownYear = _ref3.shownYear,
    startValueMonth = _ref3.startValueMonth,
    startValueYear = _ref3.startValueYear,
    value = _ref3.value,
    rangeSelection = _ref3.rangeSelection;
  if (isCurrentDayAndRangeSelection({
    current: current,
    rangeSelection: rangeSelection
  })) {
    if (value && value[0] && value[1]) {
      return current === value[1];
    }
    if (hoveredDate && value && value[0]) {
      if (startValueMonth && startValueYear && mDay && hoveredDate > value[0]) {
        return shownMonth + 1 >= startValueMonth && shownYear >= startValueYear && mDay.toString() === hoveredDay;
      } else if (hoveredDate < value[0]) {
        return value[0] === current;
      }
    }
    return false;
  }
  return false;
};
export var rangeStart = function rangeStart(_ref4) {
  var current = _ref4.current,
    hoveredDate = _ref4.hoveredDate,
    value = _ref4.value,
    rangeSelection = _ref4.rangeSelection;
  if (isCurrentDayAndRangeSelection({
    current: current,
    rangeSelection: rangeSelection
  })) {
    if (value && value[0] && value[1]) {
      return current === value[0];
    } else if (hoveredDate && value && value[0] && hoveredDate < value[0]) {
      return hoveredDate === current;
    } else if (hoveredDate && value && value[0] && hoveredDate > value[0]) {
      return current === value[0];
    }
    return false;
  }
  return false;
};
export var rangeSelected = function rangeSelected(_ref5) {
  var current = _ref5.current,
    value = _ref5.value,
    rangeSelection = _ref5.rangeSelection;
  if (isCurrentDayAndRangeSelection({
    current: current,
    rangeSelection: rangeSelection
  })) {
    if (value && value[0] && value[1] && current) {
      return current >= value[0] && current <= value[1];
    }
    return false;
  }
  return false;
};
export var selected = function selected(_ref6) {
  var current = _ref6.current,
    rangeSelection = _ref6.rangeSelection,
    value = _ref6.value;
  return rangeSelection && Array.isArray(value) ? Boolean(value === null || value === void 0 ? void 0 : value[0]) && current === value[0] || Boolean(value === null || value === void 0 ? void 0 : value[1]) && current === value[1] : Boolean(value) && current === value;
};
export var presetSelected = function presetSelected(_ref7) {
  var preset = _ref7.preset,
    value = _ref7.value;
  if (value && value[0] && value[1]) {
    return (preset === null || preset === void 0 ? void 0 : preset.range.startDate) === value[0] && (preset === null || preset === void 0 ? void 0 : preset.range.endDate) === value[1];
  }
};
export var dateToMonthArray = function dateToMonthArray(_ref8) {
  var shownMonth = _ref8.shownMonth,
    shownYear = _ref8.shownYear,
    firstDayOfWeek = _ref8.firstDayOfWeek;
  var date = new Date(shownYear, shownMonth);
  var daysInMonth = getDaysInMonth(date);
  var firstDayOfMonth = getDay(startOfMonth(date));
  var lastDayOfMonth = getDay(endOfMonth(date));
  var daysToPrepend = (firstDayOfMonth - firstDayOfWeek + 7) % 7;
  var daysToAppend = (6 - lastDayOfMonth + firstDayOfWeek) % 7;
  var month = [];
  var week = [];
  for (var i = 1 - daysToPrepend; i <= daysInMonth + daysToAppend + 1; i++) {
    var day = i > 0 && i <= daysInMonth ? i : null;
    if (week.length <= 7) {
      week.push(day);
    }
    if (week.length === 7) {
      month.push(week);
      week = [];
    }
  }
  return month;
};
//# sourceMappingURL=utils.js.map